import { Component, Input, ViewContainerRef, TemplateRef, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { CountryService } from '../../services/country/country.service';
import { User } from '../../models/user/user-model';
import { Country } from '../../models/country/country-model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { RolePermissionService } from '../../services/role/role-permission.service';
import { Router } from "@angular/router";
import { RoleService } from '../../services/role/role.service';
import { Role } from '../../models/shared/role.model';
@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.css']
})
/** user-list component*/
export class UserListComponent {
    
  public userList: User[];
  public countryList: Country[];
  public roleList: Role[];
  //Filter items from grid
  filteredItems: any[];
  public rowsOnPage: number;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public arrRowsPerPage: number[];
  public statusFilter: string;
  constructor(private readonly userService: UserService,
    private readonly utilitiesService: UtilitiesService,
    private readonly rolePermissionService: RolePermissionService,
    private readonly router: Router,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly countryService: CountryService,
    private readonly roleService: RoleService) {  
    this.toastr.setRootViewContainerRef(vcr); 
    this.statusFilter = "0";
    this.rolePermissionService.GetRolePermissions("user").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.getusers();
          this.getCountries();
          this.GetRowsPerPageList();
            this.getRole();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }

  getRole() {
    this.roleService.GetRoles().subscribe(
      data => {
        this.roleList = data;
      }
    )
  }
  UpdateFullName() {

    this.userService.UpdateUserFullName().subscribe(
      data => {
        if (data) {
          this.toastr.success('Update Successfully', 'Success')
        } else {

          this.toastr.error('Error occurred. Please try again', 'Error');
        }
      });
  }
  getCountries() {
    this.countryService.getCountries().subscribe(
      data => {
        this.countryList = data
      }
    )
  }

  getusers() {
    this.userService.getUsers().subscribe(
      data => {
        this.userList = data;
        
        this.filteredItems = data;
      }
    )
  }

  deleteUser(id) {
    if (confirm("Are you sure to delete this user ?")) {
      this.userService.deleteUser(id).subscribe(
        response => {
          if (response) {
              this.toastr.success('User has been deleted', 'Success');
            setTimeout(() => {
              this.getusers();
            }, 2000);
            }
            else {
              this.toastr.error('Error occurred. Please try again', 'Error');
            }
          }
      )
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsOnPage = this.arrRowsPerPage[0];
  }
  // Search the Grid
  onSearch() {

    var searchText = (document.getElementById("txtSearchUser") as HTMLInputElement).value;
    this.filteredItems = this.userList;

    if (searchText != "") {
      this.filteredItems = this.utilitiesService.GetSearchedResult(this.userList, searchText);
    }

    if (this.statusFilter == "true") {
      this.filteredItems = this.filteredItems.filter(u => u.isActive == true);
    }
    if (this.statusFilter == "false") {
      
      this.filteredItems = this.filteredItems.filter(u => u.isActive == false);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/user-components/user-list/user-list.component.ts